import React from 'react';
import Text from 'components/text/text';
import MakeHash from 'make-hash';
import classNames from 'classnames';

export default function LevelMeter(props) {
  const { current, max } = props;
  let levels = [];

  for (let i = 0; i < max; i++) {
    let levelClass = '';

    if ((i + 1) <= current) {
      levelClass = 'levelMeter-level_filled';
    }

    levels.push(levelClass);
  }

  return (
    <div className="levelMeter">
      <span
        className="levelMeter-current"
      >
        <Text
          color="DarkGray"
          height="flat"
          type="xl"
          weight="light"
        >
          {current}
        </Text>
      </span>

      <span
        className="levelMeter-levels"
      >
        {levels.reverse().map((level, i) => {
          return (
            <span
              className={`levelMeter-level ${level}`}
              key={MakeHash(`levelMeter-level_${i}`)}
            ></span>
          );
        })}
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/client/components/level-meter/level-meter.jsx